// URL-hash mirror for the legal documents. Opening a policy stamps
// `#policy` / `#terms` / `#cookies` on the current URL and closing it
// removes it again, so external configs that require a real URL for the
// privacy policy or terms (Google OAuth consent screen, payment providers,
// app-store listings) can point at `/fidava#policy` and land on the open
// document. replaceState is used on purpose: no history entries, and no
// `hashchange` echo back into the components that set it.
export type LegalKind = "privacy" | "terms" | "cookie";

const HASH_BY_KIND: Record<LegalKind, string> = {
  privacy: "policy",
  terms: "terms",
  cookie: "cookies"
};

const DOC_STEM_BY_KIND: Record<LegalKind, string> = {
  privacy: "privacy-policy",
  terms: "subscription-license-agreement",
  cookie: "cookie-policy"
};

export const legalDocStem = (kind: LegalKind): string => DOC_STEM_BY_KIND[kind];

export const legalKindFromDocUrl = (url: string): LegalKind | undefined =>
  (Object.keys(DOC_STEM_BY_KIND) as LegalKind[]).find((kind) => url.includes(DOC_STEM_BY_KIND[kind]));

export const readLegalHash = (): LegalKind | undefined => {
  if (typeof window === "undefined") return undefined;
  const hash = window.location.hash.replace(/^#/, "").toLowerCase();
  return (Object.keys(HASH_BY_KIND) as LegalKind[]).find((kind) => HASH_BY_KIND[kind] === hash);
};

export const setLegalHash = (kind: LegalKind | undefined): void => {
  if (typeof window === "undefined" || !kind) return;
  const { pathname, search } = window.location;
  window.history.replaceState(window.history.state, "", `${pathname}${search}#${HASH_BY_KIND[kind]}`);
};

export const clearLegalHash = (): void => {
  if (typeof window === "undefined" || !readLegalHash()) return;
  const { pathname, search } = window.location;
  window.history.replaceState(window.history.state, "", `${pathname}${search}`);
};
